import { defaults as defaultInteractions } from "ol/interaction";

/**
 * 地図に設定するインタラクションを生成する。
 *
 * @returns インタラクション
 */
export const createInteractions = () => {
    const interactions = defaultInteractions({
        altShiftDragRotate: false,
        shiftDragZoom: false,
        pinchRotate: false,
    });

    return interactions;
};
